import { useContext } from "react";
import { NavigationContext } from "./Navigationcontextprovider";

const useNavigationContext = () => {
  return useContext(NavigationContext);
};

export default useNavigationContext;
